import HeroIII from './HeroIII';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { withFilterOption } from '../../data-providers/filter';
import omit from 'lodash/omit';

const findContent = (key, id) => item => item.key === key && item.id === id;

const getFilterOptionContent = props => {
  let currentKey = props.filter.current;
  let currentValue = props.filter[currentKey];
  let filteredItem = props.items.find(findContent(currentKey, currentValue));

  if (!filteredItem) {
    let filter = omit(props.filter, [currentKey, 'current']);
    let filterKeys = Object.keys(filter);

    filteredItem = filterKeys.reduce((result, value, index) => {
      if (result) {
        return result;
      }
      currentValue = props.filter[value];
      result = props.items.find(findContent(value, currentValue));

      if (index === filterKeys.length - 1 && !result) {
        return props.items.find(findContent('none', 'none'));
      }
      return result;
    }, null);
  }

  return filteredItem.content;
};

const enhance = compose(
  withFilterOption,
  withProps(props => ({
    content: getFilterOptionContent(props)
  })),
);

export default enhance(HeroIII);



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeroIII/index.js